module.exports = __webpack_public_path__ + "static/img/china.ab173af8.png";